let isUpdated = false;
let formattedEmailArray = {};
let AllLinks = [];
let FormattedDataForLink = [];
var NotifyEmails = {
  EmailTrackerToggle: false,
  OpenedEmails: false,
  NotOpned24H: false,
  NoReply72h: false,
  OpenedManyTimes: false,
  ReopenedAfterLongTime: false,
};
let CheckCompose = 0;
let BODYtoPost = "";
let TokenFlag = 0;
let SiteResponse = "";
let Domain = "";
const encryptionKey = "MT@SuperSalt@";

let AccessToken = localStorage.getItem("MailTracker365LoginAccessToken") || "";
let SiteURL = localStorage.getItem("MailTrackerSiteURL") || "";
Office.onReady(async () => {
  console.log("Check Settings list call");
  console.log("Check Settings after list call");
  let box = document.getElementById("box");
  let htmlContent = ``;
  let Body;
  let Subject;
  let sentDate;
  let sentto;
  let OpenCounts;
  Office.onReady(async (info) => {
    // if (info.host === Office.HostType.Outlook && info.platform === Office.PlatformType.Mac) {
    //   document.getElementById("macOutlookOnly").style.display = "block";
    // }
    let AppUrl = localStorage.getItem("AppUrlLink") || "";
    document.getElementById("portalLink").href = AppUrl;
    const item = Office.context.mailbox.item;
    debugger;
    if (item) {
      if (typeof item.subject == "string") {
        document.getElementById("subject").innerText = Office?.context?.mailbox?.item?.subject;
        document.getElementById("sentTo").innerText = `Sent to ${
          Office?.context?.mailbox?.item?.to?.length > 0
            ? Office?.context?.mailbox?.item?.to?.map((x) => x?.displayName).join(", ")
            : "No recipients"
        }`;
        document.getElementById("sentTo").title =
          `${Office?.context?.mailbox?.item?.to?.length > 0 ? Office?.context?.mailbox?.item?.to?.map((x) => x.displayName).join(", ") : ""}`;
        sentDate = formatDate(Office?.context?.mailbox?.item?.dateTimeCreated) || "";
        document.getElementById("sentOn").innerText = `Sent on ${sentDate}`;

        Office?.context?.mailbox?.item?.body?.getAsync(Office.CoercionType.Html, async (result) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            let bodyContentvar = result.value;
            const extractedLastReply = bodyContentvar;
            const parser = new DOMParser();
            const doc = parser.parseFromString(extractedLastReply, "text/html");
            const imgTags = doc.querySelectorAll("img");
            if (imgTags.length <= 0) {
              document.getElementById("untackedEmails").style.display = "flex";
              document.getElementById("OpenCountsTick").style.display = "none";
              document.getElementById("Activity").style.display = "none";
            } else {
              const emailUniqueIds = Array.from(imgTags)
                ?.map((img) => {
                  const url = new URL(img.src); // Create a URL object from the src attribute
                  const params = new URLSearchParams(url.search); // Parse the query string of the URL
                  return params.get("emailUniqueId"); // Extract the value of the emailUniqueId parameter
                })
                .filter((id) => id !== null && id !== undefined && id.trim() !== ""); // Filter out null, undefined, and empty strings

              Body = doc.body.innerText || doc.body.textContent;
              // Subject = Office.context.mailbox.item.subject;
              if (emailUniqueIds?.length > 0) {
                FetchEmailData(emailUniqueIds[0]);
              } else {
                // FetchEmailData(emailUniqueIds[0]);
                document.getElementById("untackedEmails").style.display = "flex";
                document.getElementById("OpenCountsTick").style.display = "none";
              }
            }

            // document.getElementById("subject").innerText = Subject;
          } else {
            console.error("Failed to retrieve the email body:", result.error);
          }
        });
        // await getTokenAuth();
        if (item) {
          Domain = Office.context.mailbox.userProfile?.emailAddress?.split("@")[1]?.split(".")[0] || "";
          localStorage.setItem("DomainName", Domain);
        } else {
          console.log("No item is open or available.");
        }
        if (!isStringValidated(localStorage.getItem("MailTrackerSiteURL"))) {
          SiteResponse = 404;
        }
        debugger;
        getTenant();
      } else {
        console.log("Write");
      }
    }
  });

  async function FetchEmailData(emailUniqueIds) {
    const requestUrl = `https://mt.msapps365.com/api/v1/tickets-by?emailUniqueId=${emailUniqueIds}`;

    try {
      const response = await fetch(requestUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data?.user?.length > 0) {
        data?.user?.splice(0, 1);
        const sortedData = data?.user?.sort((a, b) => b.id - a.id);
        const uniqueUserIds = [...new Set(sortedData?.map((item) => item?.userId))];
        OpenCounts = sortedData?.length > 0 ? sortedData?.length : sortedData?.length;
        document.getElementById("OpenCounts").innerText = `${OpenCounts} opens`;
        const groupedUsers = sortedData?.reduce((acc, user) => {
          const date = new Date(user?.readAt);
          const formattedDate = date.toLocaleString("en-US", { month: "short", day: "numeric" });
          if (!acc[formattedDate]) {
            acc[formattedDate] = [];
          }
          acc[formattedDate].push(user);
          return acc;
        }, {});
        let htmlContent = "";
        Object.keys(groupedUsers)?.forEach((date) => {
          htmlContent += `<div style="border-bottom: 1px solid #ddd; position: relative; padding-top: 20px;"></div>
                <div class="btn">${date}</div>
                <div class="emailsGrid">`;
          groupedUsers[date]?.forEach((user) => {
            const formattedDate = new Date(user?.readAt).toLocaleString("en-US", {
              month: "short",
              day: "numeric",
            });
            const formattedTime = new Date(user?.readAt).toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            });
            htmlContent += `
          
        <div class="AllOpensEmails">
            <div class="OpenDetails">
                <i class="fa-regular fa-eye"></i>
                <div>
                    <div>
                        <span class="OpenedEmail">Opened email</span>
                        <span class="OpenEmailTime">${formattedTime}</span>
                    </div>
                    <div class="WhoOpenEmail">by ${uniqueUserIds[0]?.split?.length > 1 ? "one of the recipient" : uniqueUserIds[0]}</div>
                </div>
            </div>
        </div>`;
          });
          htmlContent += `</div>`;
        });
        box.innerHTML = htmlContent;
      }

      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }

  // const filterDuplicates = async (data) => {
  //   const seen = {};
  //   const filtered = [];
  //   data?.forEach((item) => {
  //     const deviceInfo = item.deviceInfo;
  //     const ipAddress = item.ipAddress;
  //     const createdAt = new Date(item.createdAt);
  //     const key = `${deviceInfo}|${ipAddress}`;

  //     if (seen[key]) {
  //       const prevItem = seen[key];
  //       const prevCreatedAt = new Date(prevItem.createdAt);

  //       const timeDiff = (createdAt - prevCreatedAt) / 1000;

  //       if (timeDiff < 60) {
  //         return;
  //       }
  //     }
  //     seen[key] = item;
  //     filtered.push(item);
  //   });

  //   return filtered;
  // };

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = date.toLocaleString("en-US", options);
    const formatted = formattedDate.replace(/^(.*?), (.*? \d{1,2}, \d{4}), (.*)$/, (match, day, date, time) => {
      return `${day}, ${date} at ${time}`;
    });
    return formatted;
  }
});

// async function getSettingsListData(event) {
//   if (isStringValidated(localStorage.getItem("MailTrackerSiteURL"))) {
//     const apiUrl = `${localStorage.getItem("MailTrackerSiteURL")}/_api/web/lists/getbytitle('HR365MTSettings')/items`;
//     try {
//       fetch(apiUrl, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${localStorage?.getItem("MailTracker365LoginAccessToken")}`, // Include the access token
//           Accept: "application/json; odata=nometadata",
//           "odata-version": "",
//         },
//       })
//         .then(async (response) => {
//           if (!response.ok) {
//             if (TokenFlag == 1) {
//               event.completed({ allowEvent: true });
//             } else {
//               await getToken(event);
//             }
//             throw new Error(`HTTP error! status: ${response.status}`);
//           }
//           return response.json();
//         })
//         .then(async (items) => {
//           console.log("finalEmail");
//           localStorage.setItem("ExcludedDomains", items?.value[0]?.ExcludedDomains);
//           localStorage.setItem("ExcludedAllDomainsToggle", items?.value[0]?.ExcludeAllDomains);
//           await finalSendMail(event);
//         });
//     } catch {
//       await getToken(event);
//     }
//   } else {
//     event.completed({ allowEvent: true });
//   }
// }

const msalConfig = {
  auth: {
    clientId: "18111450-56ff-43ea-8d16-924f48248d22",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "https://mtapp.msapps365.com/dialog.html",
    // redirectUri: "https://mt-apps365.azurewebsites.net/dialog.html",
    // redirectUri: "https://localhost:3000/dialog.html",
  },
};
const msalInstance = new msal.PublicClientApplication(msalConfig);
// Try to get an existing account
const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]); // ✅ Set the active account
}

function getLatestEmailBodyHTML(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  const body = doc.body;
  const container = document.createElement("div");

  for (const node of body.childNodes) {
    // Stop when reply/forward history starts
    if (node.nodeName === "HR" || (node.nodeType === 1 && node.id && node.id.includes("divRplyFwdMsg"))) {
      break;
    }

    // Clone node to avoid modifying original DOM
    container.appendChild(node.cloneNode(true));
  }

  return container.innerHTML.trim();
}

function insertDataAtEndOfBody(UniqueGuid, formattedEmailArray, AllEmailsToggles, event, conversationId) {
  console.log(conversationId);
  const URlParts = SiteURL?.split("/");
  delete formattedEmailArray["Body"];
  delete formattedEmailArray["Email"];
  // Retrieve the current body
  Office.context.mailbox.item.body.getAsync(Office.CoercionType.Html, async function (asyncResult) {
    if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
      debugger;
      const requestUrl = `https://mt.msapps365.com/api/v1/create`;
      const latestMsg = getLatestEmailBodyHTML(asyncResult.value);
      console.log(latestMsg);
      var currentBody = latestMsg;
      var attachments = Office.context.mailbox.item.attachments;
      console.log(attachments);

      const mtrk =
        AllEmailsToggles.OpenEmail == true && AllEmailsToggles.OpenManyTimes == true
          ? "yes"
          : AllEmailsToggles.OpenEmail == false && AllEmailsToggles.OpenManyTimes == true
            ? "yes"
            : AllEmailsToggles.OpenEmail == true && AllEmailsToggles.OpenManyTimes == false
              ? "no"
              : "no";

      // Construct the content with the dynamic URL
      const content = `
        <span style="display:none;">
          <img src="https://mt.msapps365.com/api/v1/read?emailUniqueId=${UniqueGuid}&userId=${formattedEmailArray?.ToWho}&senderId=${formattedEmailArray?.ByWho}&email=${formattedEmailArray?.ByWho}&mtrk=${"yes"}&tenantName=${URlParts[2].split(".")[0]}&siteName=${URlParts[4] || "root"}&conversationId=${conversationId}" style="display:none;">
        </span>
      `;
      var dataToInsert = content;
      const TRACKING_API_URL = "https://mt.msapps365.com";
      const newBodywithURL = await replaceAnchorTags(
        currentBody,
        TRACKING_API_URL,
        UniqueGuid,
        formattedEmailArray?.ByWho
      );
      var newBody = dataToInsert + newBodywithURL;
      const requestData = {
        emailUniqueId: UniqueGuid,
        userId: formattedEmailArray?.ToWho,
        email: formattedEmailArray?.ByWho,
        senderId: formattedEmailArray?.ByWho,
        tenantName: URlParts[2].split(".")[0],
        siteName: URlParts[4] || "root",
        mtrk: mtrk,
        conversationId: conversationId,
        subject: formattedEmailArray["Subject"],
        // body: JSON.stringify(newBody)
      };

      // Set the updated body content
      Office.context.mailbox.item.body.setAsync(
        newBody,
        { coercionType: Office.CoercionType.Html },
        async function (result) {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            console.log("Data successfully inserted at the end of the body.");
            try {
              const response = await fetch(requestUrl, {
                method: "POST", // Specify the request method as POST
                headers: {
                  "Content-Type": "application/json", // Set the content type as JSON
                },
                body: JSON.stringify(requestData), // Convert the data to JSON string
              })
                .then((res) => {
                  console.log(res);
                })
                .then(() => {
                  event.completed({ allowEvent: true });
                  // sendAsync(Office.context.mailbox.item).then(() => {
                  // })
                  // PostSPData(event);
                });
            } catch {
              event.completed({ allowEvent: true });
            }
          } else {
            event.completed({ allowEvent: true });
            console.error("Error setting the body: " + result.error.message);
          }
        }
      );

      // try {
      //   const response = await fetch(requestUrl, {
      //     method: "POST", // Specify the request method as POST
      //     headers: {
      //       "Content-Type": "application/json", // Set the content type as JSON
      //     },
      //     body: JSON.stringify(requestData), // Convert the data to JSON string
      //   })
      //     .then((res) => {
      //       console.log(res);
      //     })
      //     .then(() => {
      //       event.completed({ allowEvent: true });
      //       // sendAsync(Office.context.mailbox.item).then(() => {
      //       // })
      //       // PostSPData(event);
      //     });
      // } catch {
      //   event.completed({ allowEvent: true });
      // }
    } else {
      console.error("Error retrieving the body: " + asyncResult.error.message);
    }
  });
  console.log("Error");
  console.log(Office.context.mailbox.item);
}

/**
 * Shows a notification when the add-in command is executed.
 * @param event {Office.AddinCommands.Event}
 */
function action(event) {
  const message = {
    type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
    message: "Performed action.",
    icon: "Icon.80x80",
    persistent: true,
  };

  // Show a notification message.
  Office.context.mailbox.item.notificationMessages.replaceAsync("action", message);

  // Be sure to indicate when the add-in command function is complete.
  event.completed();
}

// Register the function with Office.
Office.actions.associate("action", action);

function generateGUID() {
  const buffer = new Uint8Array(16);
  window.crypto.getRandomValues(buffer);

  // Set version to 4 (UUID v4)
  buffer[6] = (buffer[6] & 0x0f) | 0x40;
  buffer[8] = (buffer[8] & 0x3f) | 0x80;

  return [...buffer]
    .map((byte, index) => {
      return (
        (index === 4 || index === 6 || index === 8 || index === 10 ? "-" : "") + byte.toString(16).padStart(2, "0")
      );
    })
    .join("");
}

function getAsyncProperty(property) {
  const mailboxItem = Office.context.mailbox.item;
  return new Promise((resolve, reject) => {
    mailboxItem[property].getAsync({ asyncContext: event }, function (asyncResult) {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve({ [property]: asyncResult.value });
      } else {
        reject(new Error(`Failed to get ${property}`));
      }
    });
  });
}

let CheckBoxdata = {};
$(document).ready(function () {
  const storedData = localStorage.getItem("NotifyEmails");
  const AllEmailsToggles = isStringValidated(storedData)
    ? JSON.parse(storedData)
    : isStringValidated(localStorage.getItem("NotifyEmails1"))
      ? JSON.parse(localStorage.getItem("NotifyEmails1"))
      : CheckBoxdata;
  $("#OpenEmailtoggle").prop("checked", AllEmailsToggles?.OpenEmail);
  $("#toggle").prop("checked", AllEmailsToggles?.TrackEmail);
  $("#OpenManyTimetoggle").prop("checked", AllEmailsToggles?.OpenManyTimes);

  $("#toggle").on("change", function () {
    updateNotifyEmails();
  });
  $("#OpenEmailtoggle").on("change", function () {
    updateNotifyEmails();
  });
  $("#OpenManyTimetoggle").on("change", function () {
    updateNotifyEmails();
  });

  CheckBoxdata = {
    TrackEmail: true,
    OpenEmail: true,
    OpenManyTimes: false,
  };
  localStorage.setItem("NotifyEmails1", JSON.stringify(CheckBoxdata));
});

function updateNotifyEmails() {
  let TrackEmail = document.getElementById("toggle");
  let OpenEmail = document.getElementById("OpenEmailtoggle");
  let OpenManyTimes = document.getElementById("OpenManyTimetoggle");
  NotifyEmails = {
    TrackEmail: TrackEmail?.checked,
    OpenEmail: OpenEmail?.checked,
    OpenManyTimes: OpenManyTimes?.checked,
  };
  console.log("Updated NotifyEmails:", NotifyEmails);
  localStorage.setItem("NotifyEmails", JSON.stringify(NotifyEmails));
}

function showLoginPopup() {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("Parent: Initiating login");
      const authResult = await authService.login();
      console.log("Parent: Authentication successful", authResult);
      resolve(authResult);
    } catch (error) {
      console.error("Parent: Authentication failed", error);
      reject(error);
    }
  });
}

async function onMessageSendHandler(event) {
  // CheckCompose = 1;
  // getSettingsListData(event);
  debugger;
  finalSendMail(event);
  // getToken(event);
}

// async function sendWithTracking(event) {
//   debugger
//   await finalSendMail(event).then(() => {
//     Office.context.mailbox.item.saveAsync(() => {
//       Office.context.mailbox.item.sendAsync((result) => {
//         event.completed();
//       });
//     });
//   })
// }

function sendAsync(item) {
  // Save first (optional but safer before send)
  return new Promise((resolve, reject) => {
    item.saveAsync((saveRes) => {
      if (saveRes.status !== Office.AsyncResultStatus.Succeeded) {
        // Not fatal—some clients allow send without prior save
        // Continue to send anyway
      }
      item.sendAsync((sendRes) => {
        if (sendRes.status === Office.AsyncResultStatus.Succeeded) resolve();
        else reject(sendRes.error);
      });
    });
  });
}

async function getToken(event) {
  TokenFlag = TokenFlag + 1;
  try {
    const response = await fetch(
      `https://mt365token.azurewebsites.net/api/token/${localStorage.getItem("MT365TenantName")}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    localStorage.setItem("MailTracker365LoginAccessToken", data?.tokens);
    setTimeout(async () => {
      finalSendMail();
      // await getSettingsListData(event);
    }, 2000);
  } catch (error) {
    event.completed({ allowEvent: true });
    console.error("Error fetching token:", error);
  }
}

function finalSendMail(event) {
  debugger;
  setTimeout(async () => {
    // if (
    //   isStringValidated(localStorage.getItem("MailTracker365LoginAccessToken")) &&
    //   isStringValidated(localStorage.getItem("MailTrackerSiteURL"))
    // ) {
    const storedData = localStorage.getItem("NotifyEmails");
    debugger;
    const AllEmailsToggles = isStringValidated(storedData)
      ? JSON.parse(storedData)
      : isStringValidated(localStorage.getItem("NotifyEmails1"))
        ? JSON.parse(localStorage.getItem("NotifyEmails1"))
        : CheckBoxdata;
    // if (isStringValidated(localStorage.getItem("MailTracker365LoginAccessToken"))) {
    if (AllEmailsToggles?.TrackEmail && (AllEmailsToggles?.OpenEmail || AllEmailsToggles?.OpenManyTimes)) {
      try {
        let UniqueID = localStorage.getItem("UniqueId");
        const properties = ["subject", "to", "from", "cc"];
        const results = await Promise.all(properties.map(getAsyncProperty));
        console.log(results);
        await Office.context.mailbox.item.body.getAsync(Office.CoercionType.Html, async (result) => {
          debugger;
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            let bodyContentvar = result.value;
            const extractedLastReply = bodyContentvar;
            const parser = new DOMParser();
            const doc = parser.parseFromString(extractedLastReply, "text/html");
            const firstParagraph = doc.querySelector("div");
            BODYtoPost = firstParagraph?.textContent || firstParagraph;
            formattedEmailArray = {
              Subject: results[0]["subject"] || "",
              ToWho: results[1]["to"]?.map((ele) => ele?.emailAddress).join(",") || "",
              ByWho: results[2]["from"]?.emailAddress || "",
              CC: results[3]["cc"]?.map((ele) => ele?.emailAddress).join(",") || "",
              Body: firstParagraph?.textContent || firstParagraph,
              Email: firstParagraph?.textContent || firstParagraph,
              UniqueGuid: UniqueID || generateGUID(),
            };
            const checkDomains = await CheckExcludedDomains(formattedEmailArray?.ToWho);
            if (checkDomains) {
              event.completed({ allowEvent: true });
            } else {
              const encryptedEmailArray = encodeEmailData(formattedEmailArray, encryptionKey);
              if (isStringValidated(Office.context.mailbox.item.conversationId)) {
                await insertDataAtEndOfBody(
                  formattedEmailArray?.UniqueGuid,
                  encryptedEmailArray,
                  AllEmailsToggles,
                  event,
                  Office.context.mailbox.item.conversationId
                );
              } else {
                await insertDataAtEndOfBody(
                  formattedEmailArray?.UniqueGuid,
                  encryptedEmailArray,
                  AllEmailsToggles,
                  event,
                  ""
                );
              }
            }
          }
        });
        console.log("run successfully");
      } catch (error) {
        event.completed({ allowEvent: true });
        console.log(error);
        alert(error);
      }
    } else {
      event.completed({ allowEvent: true });
    }
    // } else {
    //   if (TokenFlag < 1) {
    //     getToken(event);
    //   } else {
    //     event.completed({ allowEvent: true });
    //   }
    // }
    // } else {
    //   event.completed({ allowEvent: true });
    // }
  }, 100);
}

async function CheckExcludedDomains(emails) {
  const to = emails?.split(",");
  const AllExcludedDomains = isStringValidated(localStorage.getItem("ExcludedDomains"))
    ? JSON.parse(localStorage.getItem("ExcludedDomains"))
    : [];
  const ExcludedAllDomainsToggle = localStorage.getItem("ExcludedAllDomainsToggle");
  if (to?.length > 1) {
    if (ExcludedAllDomainsToggle == "Yes") {
      for (let email of to) {
        const domain = email?.split("@")[1];
        if (AllExcludedDomains.find((x) => x?.Domain == domain)) {
          return true;
        }
      }
      return false;
    } else {
      for (let email of to) {
        const domain = email?.split("@")[1];
        if (!AllExcludedDomains.find((x) => x?.Domain == domain)) {
          return false;
        }
      }
      return true;
    }
  } else if (to?.length == 1) {
    const domain = to[0]?.split("@")[1];
    if (AllExcludedDomains?.find((x) => x?.Domain == domain)) {
      return true;
    }
    return false;
  } else {
    return false;
  }
}

function encodeEmailData(formattedEmailArray) {
  const encoder = new TextEncoder();

  const base64Encode = (str) => {
    return btoa(String.fromCharCode(...encoder.encode(str)));
  };

  const encodedEmailArray = Object.keys(formattedEmailArray).reduce((acc, key) => {
    const value = formattedEmailArray[key];

    if (value) {
      // Avoid encoding null or empty values
      if (key === "ToWho" || key === "ByWho" || key === "CC" || key == "Subject") {
        acc[key] = base64Encode(value); // Proper Base64 encoding without deprecated functions
      } else {
        acc[key] = encodeURIComponent(base64Encode(value)); // Base64 + URI Encoding
      }
    } else {
      acc[key] = value; // Keep null/empty values unchanged
    }
    return acc;
  }, {});

  return encodedEmailArray;
}

function PostData(event) {
  try {
    const item = Office.context.mailbox.item;
    console.log("onMessageSendHandler triggered");
    sendAsync(Office.context.mailbox.item).then(() => {
      event.completed({ allowEvent: true });
    });
    // event.completed();
    // localStorage.removeItem("NotifyEmails");
    localStorage.removeItem("UniqueId");
  } catch (error) {
    console.error("Error in onMessageSendHandler:", error);
    event.completed({ allowEvent: true }); // Allow send in case of an error
    // event.completed();
  }
}

window.onMessageSendHandler = onMessageSendHandler;

async function PostSPData(event) {
  try {
    const url = `${SiteURL}/_api/web/lists/getbytitle('HR365MTEmails')/items`;
    // const url = "http://mt365token/api/postApi";
    console.log(formattedEmailArray);
    const requestBody = {
      Title: formattedEmailArray?.UniqueGuid,
      EmailUniqueID: formattedEmailArray?.UniqueGuid,
      Subject: formattedEmailArray?.Subject,
      toWho: formattedEmailArray?.ToWho,
      ByWho: formattedEmailArray?.ByWho,
      Body: BODYtoPost,
      OpenedEmails: "0",
    };
    if (isStringValidated(SiteURL)) {
      try {
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json;odata=nometadata",
            "Content-Type": "application/json;odata=nometadata",
            "odata-version": "*",
            Authorization: `Bearer ${localStorage.getItem("MailTracker365LoginAccessToken")}`, // Include the token in the Authorization header
          },
          body: JSON.stringify(requestBody),
        })
          .then(async (response) => {
            try {
              if (response.ok) {
                const data = await response.json();
                if (AllLinks?.length > 0) {
                  PostLinkReportData(event);
                } else {
                  PostData(event);
                }
                return data;
              } else {
                await getToken(event);
                event.completed({ allowEvent: true });
                console.error("Unexpected response:", response.status, await response.text());
              }
            } catch (error) {
              event.completed({ allowEvent: true });
              console.log(error);
            }
          })
          .catch((error) => {
            event.completed({ allowEvent: true });
            console.error("Error posting document attachment:", error);
          });
      } catch (error) {
        await getToken(event);
      }
    } else {
      event.completed({ allowEvent: true });
      console.log("site url is empty");
    }
  } catch {
    PostData(event);
  }
}

function PostLinkReportData(event) {
  const url = `${SiteURL}/_api/web/lists/getbytitle('HR365MTlinkReport')/items`;
  if (isStringValidated(SiteURL)) {
    FormattedDataForLink?.map((ele) => {
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-Type": "application/json;odata=nometadata",
          "odata-version": "*",
          Authorization: `Bearer ${localStorage.getItem("MailTracker365LoginAccessToken")}`, // Include the token in the Authorization header
        },
        body: JSON.stringify(ele),
      })
        .then(async (response) => {
          try {
            if (response.ok) {
              const data = await response.json();
              PostData(event);
              return data;
            } else {
              event.completed({ allowEvent: true });
              console.error("Unexpected response:", response.status, await response.text());
            }
          } catch (error) {
            event.completed({ allowEvent: true });
          }
        })
        .catch((error) => {
          event.completed({ allowEvent: true });
        });
    });
  } else {
    event.completed({ allowEvent: true });
    console.log("site url is empty");
  }
}

function replaceAnchorTags(body, trackingApiUrl, uniqueId, AllEmailData) {
  FormattedDataForLink = [];
  AllLinks = [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(body, "text/html");
  const anchorTags = doc.querySelectorAll("a");
  anchorTags.forEach((anchor) => {
    const UniqueLinkID = generateGUID();
    const LinkURL = anchor.href;
    const linkText = anchor.textContent || anchor.title || anchor.href;
    AllLinks.push(LinkURL);
    const newAnchorHtml = `<a href="${trackingApiUrl}/api/v1/redirect?link=${LinkURL}&uniqueId=${uniqueId}&senderId=${AllEmailData?.ByWho}&uniqueLinkId=${UniqueLinkID}">${linkText}</a>`;
    const wrapper = document.createElement("div");
    FormattedDataForLink.push({
      Title: UniqueLinkID,
      toWho: formattedEmailArray?.ToWho,
      byWho: formattedEmailArray?.ByWho,
      EmailUniqueID: uniqueId,
      Url: LinkURL,
      FirstClick: "",
      LastClick: "",
      TotalClicks: "0",
      Subject: formattedEmailArray?.Subject,
      UniqueLinkID: UniqueLinkID,
    });
    wrapper.innerHTML = newAnchorHtml;
    anchor.replaceWith(wrapper.firstChild);
  });
  return doc.body.innerHTML;
}

//Auth JS Code

async function checkTokenExpiration(par) {
  if (par != "false") {
    if (localStorage.getItem("MailTracker365LoginAccessToken")) {
      if (SiteResponse == 404) {
        document.getElementById("afterLogin").style.display = "block";
        document.getElementById("beforeLogin").style.display = "none";
        document.getElementById("loader").style.display = "none";
        document.getElementById("WaitForContent").style.display = "none";
        const dialog = document.getElementById("siteUrlDialog");
        dialog.showModal();
        SiteResponse = "";
      } else if (SiteResponse == 401) {
        document.getElementById("afterLogin").style.display = "none";
        document.getElementById("beforeLogin").style.display = "flex";
        document.getElementById("WaitForContent").style.display = "none";
        document.getElementById("siteUrlDialog").close();
        SiteResponse = "";
      } else if (SiteResponse == 101) {
        document.getElementById("afterLogin").style.display = "none";
        document.getElementById("beforeLogin").style.display = "flex";
        document.getElementById("WaitForContent").style.display = "none";
        document.getElementById("consent").style.display = "block";
        document.getElementById("loginBtn").style.display = "none";
        document.getElementById("siteUrlDialog").close();
        SiteResponse = "";
      } else {
        document.getElementById("siteUrlDialog").close();
        document.getElementById("afterLogin").style.display = "block";
        document.getElementById("beforeLogin").style.display = "none";
        document.getElementById("WaitForContent").style.display = "none";
      }
    } else {
      document.getElementById("afterLogin").style.display = "none";
      document.getElementById("beforeLogin").style.display = "flex";
      document.getElementById("WaitForContent").style.display = "none";
      localStorage.removeItem("MailTracker365LoginAccessToken");
      localStorage.removeItem("MailTrackerSiteURL");
    }
  } else {
    document.getElementById("afterLogin").style.display = "none";
    document.getElementById("beforeLogin").style.display = "flex";
    document.getElementById("WaitForContent").style.display = "none";
    localStorage.removeItem("MailTracker365LoginAccessToken");
    localStorage.removeItem("MailTrackerSiteURL");
    document.getElementById("loginBtn").style.display = "none";
    document.getElementById("consent").style.display = "block";
  }
}

async function getTenant() {
  document.getElementById("loader").style.display = "block"; // New change
  document.getElementById("WaitForContent").style.display = "block"; // New Change
  console.log(Office?.context?.mailbox?.userProfile);
  let domainName =
    localStorage.getItem(Domain) ||
    Office.context.mailbox.userProfile?.emailAddress?.split("@")[1]?.split(".")[0] ||
    "";
  const postData = {
    UserTenant: domainName,
  };
  try {
    const response = await fetch(`https://mt365token.azurewebsites.net/api/site/${domainName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    console.log("Response:", data?.responses?.value[0]?.NewTenant?.split("/")[2]?.split(".")[0]);
    localStorage.setItem("MT365TenantName", data?.responses?.value[0]?.NewTenant?.split("/")[2]?.split(".")[0]);
    await getTokenAuth();
  } catch (error) {
    console.log("Error:", error);
    await getSettingsListItems();
  }
}

let FullsiteURL = localStorage.getItem("MailTrackerSiteURL") || "https://cubiclogics";

let tenantName = isStringValidated(FullsiteURL)
  ? FullsiteURL?.toLowerCase()?.split(".sharepoint.com")[0]
  : "https://cubiclogics";

const loginRequest = {
  scopes: ["https://graph.microsoft.com/.default"], // Microsoft Graph API Scopes
};

const tokenRequest = {
  scopes: [`https://${localStorage.getItem("MT365TenantName")}` + ".sharepoint.com/Sites.FullControl.All"],
};

//LOGIN BUTTON
document.getElementById("loginBtn").addEventListener("click", async () => {
  console.log("Click");
  try {
    await CreateFirstToken();
  } catch (error) {
    if (error.errorMessage && error.errorMessage.includes("user_cancelled")) {
      console.log("Login process was cancelled. Please try again.");
    } else {
      console.error("Login Error:", error);
      console.log("An unexpected error occurred during login.");
    }
  }
});

//LOGOUT BUTTON
document.getElementById("logoutBtn").addEventListener("click", () => {
  localStorage.removeItem("MailTracker365LoginAccessToken");
  localStorage.removeItem("MailTrackerSiteURL");
  if (isStringValidated(localStorage.getItem("MailTracker365LoginAccessToken"))) {
    document.getElementById("loginBtn").style.display = "none";
    document.getElementById("logoutBtn").style.display = "flex";
    document.getElementById("afterLogin").style.display = "block";
    document.getElementById("beforeLogin").style.display = "none";
  } else {
    document.getElementById("loginBtn").style.display = "flex";
    document.getElementById("afterLogin").style.display = "none";
    document.getElementById("beforeLogin").style.display = "flex";
    document.getElementById("consent").style.display = "none";
  }
});

function isStringValidated(value) {
  if (value == null || value == undefined || value == "") {
    return false;
  } else {
    return true;
  }
}

function getSettingsListItems() {
  // document.getElementById("loader").style.display = "block";   // New change
  // document.getElementById("WaitForContent").style.display = "block"; // New Change
  let TenantURL = `https://${localStorage?.getItem("MT365TenantName")}.sharepoint.com`;
  let Token = localStorage?.getItem("MailTracker365LoginAccessToken");
  try {
    if (isStringValidated(localStorage?.getItem("MT365TenantName"))) {
      const apiUrl = `${TenantURL}/_api/web/lists/getbytitle('HR365MTSettings')/items`;
      fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`, // Include the access token
          Accept: "application/json; odata=nometadata",
          "odata-version": "",
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            SiteResponse = response.status;
            if (TokenFlag > 0) {
              checkTokenExpiration("true");
            } else {
              getTokenAuth();
            }
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          SiteResponse = "";
          SettingListID = data?.value[0]?.ID;
          localStorage.setItem("MailTrackerSiteURL", data?.value[0]?.SiteUrl);
          document.getElementById("loader").style.display = "none";
          localStorage.setItem("AppUrlLink", data?.value[0]?.AppUrl);
          document.getElementById("portalLink").href = data?.value[0]?.AppUrl;
          checkTokenExpiration("true");
        })
        .catch((error) => {
          console.error("Error fetching list items:", error);
        });
    } else {
      getTenant();
    }
  } catch {
    console.log("error while getting settings list data");
  }
}

//Create first Token
async function CreateFirstToken() {
  const loginRequest = {
    scopes: [`https://${localStorage.getItem("MT365TenantName")}` + ".sharepoint.com/Sites.FullControl.All"],
  };
  const loginResponse = await msalInstance.loginPopup(loginRequest);
  localStorage.setItem("MailTracker365LoginAccessToken", loginResponse.accessToken);
  // getSettingsListItems();
  getTenant();
}

async function getTokenAuth() {
  // document.getElementById("loader").style.display = "block"; // New change
  // document.getElementById("WaitForContent").style.display = "block"; // New Change
  if (isStringValidated(localStorage.getItem("MT365TenantName"))) {
    TokenFlag = TokenFlag + 1;
    try {
      const response = await fetch(
        `https://mt365token.azurewebsites.net/api/token/${localStorage.getItem("MT365TenantName")}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      } else {
        const data = await response.json();
        if (data?.error) {
          SiteResponse = 101;
          checkTokenExpiration("false");
        } else {
          SiteResponse = "";
          document.getElementById("consent").style.display = "none";
          localStorage.setItem("MailTracker365LoginAccessToken", data?.tokens);
          checkTokenExpiration("true"); // New change
          setTimeout(() => {
            // New change
            getSettingsListItems();
          }, 2000); // New change
        }
      }
    } catch (error) {
      console.error("Error fetching token:", error);
    }
  } else {
    getTenant();
  }
}

document.getElementById("consent").addEventListener("click", async () => {
  try {
    const tenantName = localStorage.getItem("MT365TenantName");
    window.open(`https://mt365token.azurewebsites.net?tenantName=${tenantName}`, "_blank");
    document.getElementById("loginBtn").style.display = "block";
    document.getElementById("consent").style.display = "none";
  } catch (error) {
    if (error.errorMessage && error.errorMessage.includes("user_cancelled")) {
      console.log("Login process was cancelled. Please try again.");
    } else {
      console.error("Login Error:", error);
      console.log("An unexpected error occurred during login.");
    }
  }
});

//Test for Macbook only

document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("addApiImageBtn");

  button.addEventListener("click", function () {
    addApiImage();
  });
});

function addApiImage() {
  console.log("Button clicked!");
  const content = `
        <span>
        Testing text for macbook
          <img src="https://ik.imagekit.io/zn4au2jftpm5/New%20/HR365Colored.png">
        </span>
      `;
  // const content = `<div class="test">Testing text for macbook</div><a href="https://mt.msapps365.com/api/v1/read?emailUniqueId=${formattedEmailArray?.UniqueGuid}&userId=${formattedEmailArray?.ToWho}&senderId=${formattedEmailArray?.ByWho}&email=${formattedEmailArray?.ByWho}&mtrk=${"yes"}&tenantName="cubiclogics"&siteName=${"MailTracker365"}&conversationId=""">Google</a>`;
  Office.context.mailbox.item.body.setAsync(
    content,
    { coercionType: Office.CoercionType.Html },
    async function (result) {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        console.log("Data successfully inserted at the end of the body.");
      } else {
        console.error("Error setting the body: " + result.error.message);
      }
    }
  );
}

// document.addEventListener("DOMContentLoaded", function () {
//   const container = document.getElementById("macOutlookOnly");
//   const userAgent = navigator.userAgent.toLowerCase();

//   const isMac = userAgent.includes("mac");
//   const isOutlook = userAgent.includes("outlook") || userAgent.includes("microsoft office");

//   if (isMac && isOutlook) {
//     container.style.display = "block";
//   }
// });
